import '../sass/app.scss';
require('waypoints/lib/noframework.waypoints.min');
require('./custom_waypoints.js');


(function($) {

$(document).ready(function() {
	$("body").addClass("relative "); //not-loaded
	var footerH = $('#footer-inner').height();
	$("#page").css("margin-bottom", footerH);
	// Monitor contact form input fields
	var wpcf7fields = $('.wpcf7-fieldwrapper');
	$(wpcf7fields).each(function(i,el){
		var field = $(el).find('input');

		if (field.length == 0) {
			var textArea =  $(el).find('textarea');
			if (textArea.length > 0) {
				field = textArea;
			}
		}

		if (field.val() != "") {
			$(el).addClass('wpcf7-field-filled');
		} else {
			$(el).removeClass('wpcf7-field-filled');
		}

		// Add listeners
		field.keyup(function() {
			var val = $(this).val();
			if (val != "") {
				$(el).addClass('wpcf7-field-filled');
			} else {
				$(el).removeClass('wpcf7-field-filled');
			}
		})
	})

	// Fading link
	let pageLoadedEvent = new Event("pageLoaded");
	var fadeLinks = $('.fade-link');

	$(fadeLinks).each(function(i,el) {
		if ( $(el).attr('target') != '_blank') {
			$(el).on('click', function(e){
				e.preventDefault();
				var clickedLink = this.getAttribute("href"); 
				// $("body").addClass("not-loaded");
				$('#page-loader').removeClass('page-loaded');
				window.setTimeout(function(){
			         window.location = clickedLink;
			    }, 500); 
			})
		}
	})

	$(window).on('load', function(){
		$("body").removeClass('not-loaded');
		$('#page-loader').addClass('page-loaded');
		window.setTimeout(function(){
			window.dispatchEvent(pageLoadedEvent);
		}, 500)
		
	})
})
	
})( jQuery );